export const CSRF_TOKEN_COOKIE_KEY = 'csrftoken';
export const OO_UPSELL_HEADER_AB = 'oo_upsell_header_ab';
